<div *ngIf="isAuthenticated">
  <img src="https://www.writeitforme.com/images/typewriter.png" />
  <h2>Wifm Search</h2>
  <div *ngIf="busyClient">
    Loading Clients...
  </div>
  <div *ngIf="!busyClient">
    Select Client:&nbsp;
    <select [(ngModel)]="client">
      <option value="">-- Select Client --</option>
      <option *ngFor="let c of clientList" value="{{c}}">{{c}}</option>
      <option value="ALL">Cross-Client All Search</option>
    </select>

    <div style="float: right;">
      <a style="font-size: 8pt; margin-top: 500px;" href="#" (click)="clearCache($event)">(Admin) Clear Company Cache</a>
    </div>
    <div style="clear: both;"></div>

  </div>

  <div style="margin-top: 20px;" *ngIf="client != ''">
    <div style="border: 1px solid #666; font-size: 8pt;">
      <a target="_blank" href="https://lucene.apache.org/core/2_9_4/queryparsersyntax.html">Apache Lucene - Query Parser Syntax</a>
      <br />
      <a target="_blank" href="https://learn.microsoft.com/en-us/azure/search/query-lucene-syntax">Search Syntax Document</a>
      <table>
        <tr>
          <td>Misc Words</td>
          <td>mental health</td>
        </tr>
        <tr>
          <td>Exact Match</td>
          <td>"mental health"</td>
        </tr>
        <tr>
          <td>AND</td>
          <td>mental AND health</td>
          <td>MUST BE UPPER CASE. Will rank documents higher if they have both terms. As opposed to + which will exclude documents without the term.
          </td>
        </tr>
        <tr>
          <td>Must Include</td>
          <td>+cyberbullying</td>
          <td>Exclude documents without the term</td>
        </tr>
        <tr>
          <td>Must NOT Include</td>
          <td>-cyberbullying</td>
          <td>Exclude documents with the term</td>
        </tr>
        <tr>
          <td>Wildcard</td>
          <td>
            healt*
          </td>
          <td>wildcard / stemming</td>
        </tr>
        <tr>
          <td>Proximity Search</td>
          <td>
            "office family"~6
          </td>
          <td>finds the terms office and family
            within 6 words of each other
          </td>
        </tr>
        <tr>
          <td>Term Boost</td>
          <td>
            Violence^4</td>
          <td>
            ranks documents with the term violence higher/boosted score
          </td>
        </tr>
        <tr>
          <td>Field Search</td>
          <td>
            +metadata_storage_name:"final"
            <br />
            +metadata_storage_path:"wifmdocuments/CN Guidance"
            <br />
            +metadata_storage_path:"SAMHSA"
          </td>
          <td>
            <b>Document name</b> must have the word final in it<br />
            <b>Full Path</b> must have the client "CN Guidance" in it<br />
            <b>Full Path</b> must have the funder "SAMHSA" in it<br />
          </td>
        </tr>
      </table>

    </div>
    <br />

    <span *ngIf="this.client != 'ALL'">Searching ONLY {{this.client}}</span>
    <input type="text" style="width: 100%;" [(ngModel)]="q" (keyup.enter)="doSearch()" />

    <br /><br />
    <button (click)="doSearch()" [disabled]="isSearching">Search</button>
    &nbsp;&nbsp;
    Responses
    <select [(ngModel)]="numResponses">
      <option value="10">10</option>
      <option value="20">20</option>
      <option value="30">30</option>
      <option value="40">40</option>
      <option value="50">50</option>
      <option value="60">60</option>
    </select>
    &nbsp;&nbsp;
    Bullets
    <select [(ngModel)]="numBullets">
      <option value="3">3</option>
      <option value="4">4</option>
      <option value="5">5</option>
      <option value="6">6</option>
      <option value="7">7</option>
      <option value="8">8</option>
    </select>

    <br /><br />
    <div *ngIf="numResults >= 0">{{numResults}} Results</div>
    <div style="border: 1px solid #009900" *ngIf="results.length > 0">
      <div *ngFor="let result of results">
        <div style="padding: 15px;">
          <div>
            <span style="font-size: 14pt; font-weight: bold;">{{result.metadata_storage_name}}</span>
            &nbsp;&nbsp;&nbsp;
            <span class="score" [ngClass]="{
                    'high' : result['@search.score']>
                3,
                'medium': result['@search.score'] > 2 && result['@search.score'] < 3,
                'low': result['@search.score'] > 1 && result['@search.score'] < 2,
                'bad': result['@search.score'] > 0 && result['@search.score'] < 1
                }">
              (Score: {{result['@search.score']}})
            </span>
          </div>
          <div *ngIf="result.metadata_title">
            <span style="font-size: 10pt;">Title: </span>
            <span style="font-size: 10pt; color: darkorchid;">{{result.metadata_title}}</span>
          </div>
          <div>
            <span style="font-size: 10pt; color: darkorange;">{{getPath(result.metadata_storage_path)}}</span>
          </div>
          <ul *ngIf="result['@search.highlights']?.content">
            <li *ngFor="let highlight of result['@search.highlights'].content" [innerHtml]="safe(highlight)"></li>
          </ul>
          <ul *ngIf="!result['@search.highlights']?.content">
            <li>NO MATCHES</li>
          </ul>
        </div>
        <hr />
      </div>
    </div>
  </div>

  <br /><br /><br /><br /><br /><br /><br />
</div>